import styled from 'styled-components'

/* DS TextField doesn't pad its adornments (Q-9): Figma's 24px icon frame
   around a 16px glyph, padded to the field's inner height; the left padding
   adds to the input's own 12px for the 16px text gap. */
export const SearchIconFrameStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: content-box;
  width: ${({ theme }) => theme.typography.pxToRem(24)};
  height: ${({ theme }) => theme.typography.pxToRem(24)};
  padding: ${({ theme }) => theme.space.small};
  padding-left: ${({ theme }) => theme.space.xsmall};
`
